"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
const isDetailedExportedProvider = (data) => {
    return !!data && typeof data === "object" && "provide" in data;
};
exports.default = isDetailedExportedProvider;
